module.exports = __webpack_public_path__ + "img/2w.d2fa01f0.svg";